export default "__VITE_ASSET__CYd1FKiw__"